/*
 * Landing Page Tracker
 * ------------------------------------------------------------
 * Whenever a customer visits one of the page handles listed in
 * LANDING_PAGE_HANDLES below, this stamps the cart with note
 * attributes (landing page, URL, referrer, UTM params, timestamp).
 * Those attributes ride along into checkout and show up on the
 * order under "Additional details" in the Shopify admin.
 *
 * A Shopify Flow ("Tag orders from tracked landing pages") reads the
 * "Landing Page" attribute on order_created and tags the order
 * accordingly — it doesn't need its own copy of this list, so adding
 * or removing a handle here is the only change needed to track (or
 * stop tracking) a page.
 *
 * Last-touch model: visiting a tracked landing page overwrites any
 * previous attribution stored from an earlier visit in this browser.
 *
 * LANDING_PAGE_HANDLES below is every currently-published page on
 * onesol.com that isn't a generic site page (about, policies,
 * rewards, supplement facts, etc). Add or remove a handle here to
 * track (or stop tracking) a page — no other change needed.
 * ------------------------------------------------------------
 */
(function () {
  var LANDING_PAGE_HANDLES = [
    'preworkout',
    'one-sol™-fat-burner',
    'weekly-workout',
    'how-to-build-your-salad',
    'michelle-carreno',
    'bbl-creatine',
    'bbl-creatina',
    '5-weight-loss-secrets',
    '2025-woman-of-the-year-bundle',
    'one-sol-scholarship-application',
    'one-sol-scholarship',
    '4-step-formula-fitter-you',
    'the-diy-bbl-kit',
    'the-hourglass-kit',
    'one-sol-scholarship-application-2',
    'scholarship-before-you-go',
    'new-one-sol-scholarship',
    'booty-growth-with-protein',
    'onesol-scholarship',
    'one-sol-creatine-todays-offer',
    'one-sol-creatine-todays-offer-sf',
    'one-sol-creatine-todays-offer-2',
    'one-sol-creatine-todays-offer-sf-2',
    'intro-offer',
    'one-sol-creatine-starter-kit',
    'one-sol-creatine-sk',
    'one-sol-creatine-starter-kit-2',
    'one-sol-creatine-starter-kit-3',
    'one-sol-creatine-sk-sourcherry',
    'one-sol-creatine-sk-unflavored',
    'one-sol-creatine-sk-unflavored-v2',
    'one-sol-creatine-sk-sourcherry-v2',
    'one-sol-deodorant',
    'one-sol-creatine-leucine-starter-kit',
    'one-sol-creatine-peri',
    'one-sol™-creatine-leucine-starter-kit-je',
    'one-sol-creatine-sk-mango-v2',
    'one-sol-creatine-sk-mango',
    'intro-offer-2',
    'one-sol-creatine-sk-mango-v3',
    'one-sol-creatine-sk-sourcherry-v3',
    'one-sol-creatine-sk-unflavored-v3',
    'one-sol-creatine-sk-mango-v4',
    'one-sol-creatine-sk-sourcherry-v4',
    'one-sol-creatine-sk-unflavored-v4',
    'one-sol-creatine-sk-sourcherry-v5',
    'one-sol-creatine-sk-unflavored-v5',
    'one-sol-creatine-sk-mango-v5',
    'one-sol-creatine-sk-mix',
    'one-sol-creatine-sk-add',
    'one-sol-creatine-sk-add-v2',
    'one-sol-creatine-sk-mix-v2',
    'one-sol-creatine-sk-list',
    'one-sol-creatine-sk-list-v2',
    'hydration-starter-kit',
    'lose-the-belly-2',
    'intro-offer-copy',
    'lose-the-belly-1',
    'one-sol-hydration-starter-kit-pau',
    'intro-offer-3',
    'one-sol-lean-plant-protein-starter-kit',
    'one-sol-lean-plant-protein-starter-kit-v2',
    'one-sol-lean-plant-protein-starter-kit-v2-flavor-selection'
  ];

  var STORAGE_KEY = 'os_landing_attribution';
  var SESSION_SYNCED_KEY = 'os_landing_synced';

  function getUtmParams() {
    var params = new URLSearchParams(window.location.search);
    var utm = {};
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'].forEach(function (key) {
      var val = params.get(key);
      if (val) utm[key] = val;
    });
    return utm;
  }

  function currentPageHandle() {
    var body = document.body;
    return body ? body.getAttribute('data-page-handle') || '' : '';
  }

  function buildAttributionRecord(handle) {
    return {
      handle: handle,
      url: window.location.href,
      referrer: document.referrer || '',
      utm: getUtmParams(),
      timestamp: new Date().toISOString()
    };
  }

  function readStored() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  }

  function writeStored(record) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(record));
    } catch (e) {}
  }

  function syncCartAttributes(record) {
    var attributes = {
      'Landing Page': record.handle,
      'Landing URL': record.url,
      'Landing Referrer': record.referrer,
      'Landing Visited At': record.timestamp
    };
    Object.keys(record.utm || {}).forEach(function (key) {
      attributes['Landing ' + key] = record.utm[key];
    });

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: attributes })
    }).then(function () {
      try { window.sessionStorage.setItem(SESSION_SYNCED_KEY, '1'); } catch (e) {}
    }).catch(function () {});
  }

  function init() {
    var handle = currentPageHandle();
    var isLandingPage = handle && LANDING_PAGE_HANDLES.indexOf(handle) !== -1;

    if (isLandingPage) {
      var record = buildAttributionRecord(handle);
      writeStored(record);
      syncCartAttributes(record);
      return;
    }

    // Not a tracked landing page this time — make sure any attribution
    // captured earlier in this browser still rides along at least once
    // per session, in case the cart was recreated since that visit.
    var alreadySynced = false;
    try { alreadySynced = window.sessionStorage.getItem(SESSION_SYNCED_KEY) === '1'; } catch (e) {}
    if (alreadySynced) return;

    var stored = readStored();
    if (stored) syncCartAttributes(stored);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
